import { useEffect } from 'react'
import type { EmblaCarouselType } from 'embla-carousel'
import type { DirectionKind } from '..'

export interface IControllerProps {
  itemIndex: number
  emblaApi?: EmblaCarouselType
  onHandleNavigation?: (direction: DirectionKind) => void
}

export const Controller = ({ emblaApi, itemIndex, onHandleNavigation }: IControllerProps) => {
  useEffect(() => {
    if (emblaApi) {
      const currentIndex = emblaApi.selectedScrollSnap()
      emblaApi.scrollTo(itemIndex)

      if (onHandleNavigation) {
        onHandleNavigation(itemIndex > currentIndex ? 'next' : 'prev')
      }
    }
  }, [emblaApi, itemIndex, onHandleNavigation])

  return null
}

Controller.displayName = 'Carousel.Controller'
